import { IBreadcrumbItem, PanelType } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import {
  IconButton,
  iconButtonStylesNoBG,
  IPageHeaderProps,
  IPanelProps,
  PageHeader,
  pageHeaderStylesSecondary,
  Panel,
  useClassNames,
} from '@h2oai/ui-kit';
import { useEffect } from 'react';

import { ListableFeatureSet } from '../../featurestore/gen/ai/h2o/featurestore/api/v1/CoreService.pb';
import { ContentsTitle, defaultPanelWidth } from '../../featurestore/models';
import { Retrieve } from '../Retrieve/Retrieve';
import { IRetrievePanelClassNames, IRetrievePanelStyles, retrievePanelStylesDefault } from './RetrievePanel.styles';

const getBreadcrumbItems = (name = ''): IBreadcrumbItem[] => {
  return [
    { text: `${ContentsTitle.featureSet}: ${name}`, key: `${ContentsTitle.featureSet} ${name}` },
    {
      text: ContentsTitle.retrieve,
      key: ContentsTitle.retrieve,
      isCurrentItem: true,
    },
  ];
};

interface IRetrievePanelProps {
  featureSet?: ListableFeatureSet;
  show: boolean;
  onDismiss: (
    ev?: KeyboardEvent | React.SyntheticEvent<HTMLElement, Event> | undefined,
    updated?: boolean,
    isOnline?: boolean
  ) => void;
}

export const RetrievePanel = ({ featureSet, show, onDismiss }: IRetrievePanelProps) => {
  const [isOpen, { setTrue: open, setFalse: close }] = useBoolean(false);
  const panelProps: IPanelProps = {
    type: PanelType.custom,
    customWidth: defaultPanelWidth,
    isOpen,
    onDismiss,
    isFooterAtBottom: true,
    hasCloseButton: false,
  };

  const pageHeaderProps: IPageHeaderProps = {
    pageTitle: ContentsTitle.retrieve,
    styles: pageHeaderStylesSecondary,
    breadcrumbProps: {
      items: getBreadcrumbItems(featureSet?.name),
    },
    actions: <IconButton styles={iconButtonStylesNoBG} iconName="Clear" onClick={() => onDismiss()} />,
  };

  useEffect(() => {
    if (show) {
      open();
    } else {
      close();
    }
  }, [show]);
  const classNames = useClassNames<IRetrievePanelStyles, IRetrievePanelClassNames>(
    'RetrievePanel',
    retrievePanelStylesDefault
  );
  return (
    <Panel {...panelProps}>
      <div className={classNames.root}>
        <PageHeader {...pageHeaderProps} />
        <Retrieve
          featureSet={featureSet}
          onSave={(isOnline) => onDismiss(undefined, true, isOnline)}
          onCancel={onDismiss}
        />
      </div>
    </Panel>
  );
};
